import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbPopover, NgbModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SmErrorModule } from '../sm-error/sm-error.module';
import { SmDatePickerComponent } from './sm-datepicker.component';



@NgModule({
  declarations: [SmDatePickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    SmErrorModule,
    NgbPopover,
    NgbModule,
    BsDatepickerModule.forRoot(),
    NgbDatepickerModule
  ],
  providers: [BsDatepickerConfig, DatePipe],
  exports: [SmDatePickerComponent]
})
export class SmDatepickerModule { }
